import * as moment from 'moment';
import { dateFormatString } from '../config/app.config';

export default class Utils {
  static getFormatedDate(date) {
    return moment(date).format(dateFormatString);
  }

  // Thanks to Brian Ustas on SO: https://stackoverflow.com/a/11832950/227167
  static roundMoneyAmount(amount: number): number {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
  }

  static async sleep(milliseconds: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, milliseconds);
    });
  }

  static postMessageToParentWindow(messageType: MessageType, data: any) {
    window.parent.postMessage({ messageType, data }, '*');
  }
}

export enum MessageType {
  height = 'height',
  paynet = 'paynet',
  focus = 'focus',
}
